import { set, get } from 'utils/idb-keyval';
import { Action } from 'redux';
import { HeaderState } from 'models/HeaderState';
import { historyPushState } from 'store/history/actions';
import { createHref } from 'components/Shared/server';
import { SiteMode } from 'models/SiteMode';
import { getPage } from 'components/Pagelayout/actions';
import { ThunkDispatch } from 'components/Shared/connect';
import { reloadCart } from 'components/Cart/actions';
import { AppShellManifest } from 'models/AppShellManifest';
import { isProductlist } from 'views/ProductlistPage/selectors';
import { bridge } from '@bygghemmait/core';

export const APPSHELL_OPTIONS = 'APPSHELL_OPTIONS';
export const APPSHELL_UPDATE = 'APPSHELL_UPDATE';
export const APPSHELL_CACHE_LOAD = 'APPSHELL_CACHE_LOAD';
export const APPSHELL_CACHE_SAVE = 'APPSHELL_CACHE_SAVE';
export const APPSHELL_SET_SITE_MODE = 'APPSHELL_SET_SITE_MODE';

export interface AppShellParams {
  appShell: AppShellManifest;
}

export const appShellCacheLoad = () => {
  void get<AppShellManifest>('appShell').then((appShell: AppShellManifest) => {
    /* eslint-disable-next-line no-console */
    console.log('appShell Loaded:', appShell);
  });
};

export const appShellCacheSave = ({ appShell }: AppShellParams) => {
  void set('appShell', appShell).then(() => {
    /* eslint-disable-next-line no-console */
    console.log('appShell Saved:', appShell);
  });
};

export interface SetSiteModeAction extends Action {
  siteMode: SiteMode;
}

const _setSiteMode = (mode: SiteMode) => ({
  type: APPSHELL_SET_SITE_MODE,
  siteMode: mode
});

export const setSiteMode =
  (mode: SiteMode, reloadPage = true) =>
  (dispatch: ThunkDispatch, getState: () => HeaderState) => {
    const state = getState();
    document.cookie = `bhsm=${mode}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
    dispatch(_setSiteMode(mode));
    bridge.dispatch('updatedSiteMode', mode);

    if (state.appShell.siteMode !== mode) {
      const url = createHref(state.location);
      url.search.mode = mode.toString();

      if (isProductlist(state.currentPage)) {
        // ProductList has attributes that might differ from
        // sitemodes, we want to remove them to reset
        // the filters
        state.currentPage.siteModeSpecificClearAttributes
          ?.filter(attribute => !!url.search[attribute])
          .forEach(attribute => {
            delete url.search[attribute];
          });
      }

      if (window.isReact) {
        return reloadPage
          ? Promise.all([dispatch(reloadCart()), dispatch(getPage(url))])
          : dispatch(reloadCart());
      } else {
        dispatch(
          historyPushState({
            url
          })
        );
        location.reload();
        return Promise.resolve();
      }
    }
    return Promise.resolve();
  };
